<template>
  <v-card class="confirm-account px-4 elevation-0">
    <v-card-title
      class="white--text confirm-account__title pb-0 px-0 title-info text-uppercase"
      >{{ $t("checkout.accountConfirmation.title") }}</v-card-title
    >
    <v-card-subtitle
      class="my-3 white--text confirm-account__subtitle px-0 title-info"
    >
      {{ $t("checkout.accountConfirmation.subtitle") }}
    </v-card-subtitle>
  </v-card>
</template>
<style scoped>
.card-complete-profile {
  margin-bottom: 15px;
}
</style>
<script>
export default {
  name: "PaymentCompleteProfile"
};
</script>

<style lang="scss" scoped>
.confirm-account {
  background-color: #d0091b;
  &__title {
    font-size: 16px;
  }
}
</style>
